import { async } from '@firebase/util';
import { db, storage } from '../src/config/firebase-config';
import { collection, getDocs,getDoc, addDoc, doc, updateDoc, deleteDoc, arrayUnion, increment} from 'firebase/firestore'
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
export class FirebaseHelper {
    constructor(docName) {
        this.usersCollectionRef = collection(db, docName);
        this.docName = docName;
    }

    static createDoc = async (collectionRef, object) => {
        return await addDoc(collectionRef,object)
    }

    static updateDoc = async (collection, id, field) => {
        const fireDoc = doc(db, collection, id);
        //const newFields = { age: age + 1 };
        await updateDoc(fireDoc,field);
    }


    static deleteDoc = async (docName, id) => {
        const userDoc = doc(db, docName, id);
        await deleteDoc(userDoc);
    }

    static deleteStorage = async (type, id,name) => {
        const storageRef = ref(storage, "/Files/" +type+ id+"/"+name);
        deleteObject(storageRef);
    }

    static getDoc = async (collection, id) => {

        const docRef = doc(db, collection, id)
        const docSnap = await getDoc(docRef)
        return docSnap.data();

    }

    static getAllDocs = async (usersCollectionRef) => {
        const data = await getDocs(usersCollectionRef);
        return await data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    }

    static uploadFiles = (file, id, setProgress) => {
        if (!file) return;
        const storageRef = ref(storage, "/Files/" + id);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed", (snapshot) => {
            const prog = Math.round(
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(prog);
        },
            (err) => console.log(err),
            /*()=>{
              getDownloadURL(uploadTask.snapshot.ref)
              .then((url)=>{setUrl(url)});
            }*/
        );
    }
    static uploadWallpaper(file, id, setProgress, setWallpaperUrl) {
        this.uploadFiles(file, "Wallpapers/" + id, setProgress, setWallpaperUrl)
    }
    static uploadPostImages(images, id) {
        this.uploadFiles(images.wallpaper, "PostImages/" + id + "/wallpaper",);
        this.uploadFiles(images.thumbnail, "PostImages/" + id + "/thumbnail",);
    }

    static getImage = async (path, id, src) => {
        const storageRef = ref(storage, "/Files/" + path + "/" + id + "/" + src);
        return await getDownloadURL(storageRef)
    }


    
    static addComment(id, comment){
        var collectionRef = collection(db, "comments");
        this.createDoc(collectionRef,comment).then((snapshot)=>{
            this.updateDoc("posts",id,{
                comments:arrayUnion(snapshot.id)
            });

        });
        
    }

    static increaseView(collection, id){
        var increaseField = {
            views:increment(1)
        };
        this.updateDoc(collection,id,increaseField);
    }

    static increaseLikes(collection, id){
        var increaseField = {
            likes:increment(1)
        };
        this.updateDoc(collection,id,increaseField);
    }
    static increaseDislikes(collection, id){
        var increaseField = {
            dislikes:increment(1)
        };
        this.updateDoc(collection,id,increaseField);
    }

    static decreaseLikes(collection, id){
        var increaseField = {
            likes:increment(-1)
        };
        this.updateDoc(collection,id,increaseField);
    }
    static decreaseDislikes(collection, id){
        var increaseField = {
            dislikes:increment(-1)
        };
        this.updateDoc(collection,id,increaseField);
    }

}